module.exports = __webpack_public_path__ + "img/businessman.ecd5a090.svg";